import script from "./dateFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./dateFilter.vue?vue&type=script&setup=true&lang=js"

import "./dateFilter.vue?vue&type=style&index=0&id=5a6c8239&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a6c8239"]])

export default __exports__